import * as React from "react";
import { IconProps } from "./types";

export const ArrowDownRightIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M7 7L17 17M17 17V7M17 17H7"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          stroke={color}
        />
      </svg>
    );
  },
);
(ArrowDownRightIcon as React.FunctionComponent).displayName =
  "ArrowDownRightIcon";

export default ArrowDownRightIcon;
